import { render, staticRenderFns } from "./ServiceFormAgeCount.vue?vue&type=template&id=bc329396&scoped=true&"
import script from "./ServiceFormAgeCount.vue?vue&type=script&lang=js&"
export * from "./ServiceFormAgeCount.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormAgeCount.vue?vue&type=style&index=0&id=bc329396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc329396",
  null
  
)

export default component.exports